import logo from "../public/vertex-logo.png";

const Restricted = () => {
  return (
    <div className="mt-10 md:mx-32">
      <div className="flex justify-center">
        <img src={logo} alt="logo" className="object-contain w-32" />
      </div>
      <div className="flex flex-col mt-44">
        <p className="text-primary-text text-center text-4xl font-bold">
          Notice
        </p>
        <div className="mt-8 flex justify-center">
          <p className="text-secondary-text text-center whitespace-normal">
            The Vertex Trading competition is available ONLY to non-US
            residents. You will not be eligible to participate if you reside in
            the United States.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Restricted;
